import { createAction } from 'redux-actions';

import * as actionTypes from './actionTypes';

export const setAppTitle = createAction(actionTypes.SET_APP_TITLE, (title: string) => title);

export const setAppFooter = createAction(
  actionTypes.SET_APP_FOOTER,
  (footerConfig: FooterConfig | null) => footerConfig,
);
